/**
 * IMPORT
 */
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ModalCreateStepComponent} from "../sequence-step/modal-create-step/modal-create-step.component";
import {ExcRestService} from "exc-rest";

/**
 * COMPONENT
 */
@Component({
  selector: 'app-sequence',
  templateUrl: './sequence.component.html',
  styles: []
})
/**
 * Klasse für die Initialisierung der Sequenzen eines Selfchecks. <br>
 * @version Angular 7.0.0 <br>
 * @since 15.11.2022 <br>
 * xx.xx.xxxx wg. Evaluierung <br>
 * 15.11.2022 wg. Dokumentation <br>
 * @author Denny M. Lüdicke <br> E-Mail: denny.luedicke@excon.com <br>
 * Veränderungen von Denny M. Lüdicke
 */
export class SequenceComponent extends ExcTranslation implements OnInit {
  /**
   * INPUT
   **/
  @Input('sequence') sequence;
  @Input('verificationKey') verificationKey;
  @Input('selfcheckMode') selfcheckMode;
  @Input('enumeration') enumeration;

  @Output() reloadSummary: EventEmitter<any> = new EventEmitter<any>();

  /**
   * ATTRIBUTE
   */
  valueCreateStepDialog = false;
  valueDeleteStepDialog = false;
  sequenceIsLoading = false;
  checkboxValue = false;
  checkedSsIdArray = [];
  checkedSsIdArrayValue = false;
  switchMode = false;
  /**
   * Workspace
   */
  sequenceWorkspace =
    {
      changeSsOrder: (step: any, direction: number) => {
        if (!((step.ssOrder === 1 && direction < 0) || (step.ssOrder === this.sequence.Steps.length && direction > 0))) {
          let actual = step;
          let second = this.sequence.Steps.find((ssOrder) => ssOrder.ssOrder === actual.ssOrder + direction);
          let tmpSortOrder = step.ssOrder;

          if (actual && second) {
            actual.ssOrder = second.ssOrder;
            second.ssOrder = tmpSortOrder;
            this.sequenceWorkspace.changeStep(second);
            this.sequenceWorkspace.changeStep(actual);
          }
        }
      },
      changeStep: (step: any) => {
        let ssID = step.ssID;

        Object.assign(step, {ss_stID: step.stID});
        this.sequenceIsLoading = true;
        this.excrest.post(this.excrest.computeUrl
          (
            'SelfcheckConfig_Step_Post', {ssID}
          ),
          step, {}
        ).subscribe
        (response => {
          if (response.success && response.data.length >= 0) {
            for (let i = 0; i < this.sequence.Steps.length; i++) {
              if (this.sequence.Steps[i].ssID === response.data[0].ssID) {
                Object.assign(response.data[0], {stID: response.data[0].ss_stID});
                this.sequence.Steps[i] = response.data[0];
              }
            }
          }
          this.sequenceIsLoading = false;
        });
      },
    }

  /**
   * METHODEN
   */
  /**
   * @param constructor( excrest )
   */
  constructor(private excrest: ExcRestService) {
    super();
  }

  /**
   * @param ngOnInit()
   **/
  ngOnInit() {
  }

  /**
   * Krüppelfix
   */
  getSortSequenceStepArray() {
    if (!this.sequence.Steps) {
      return [];
    } else {
      return this.sequence.Steps.sort(
        // Sortelement of Sortmenue
        (a, b) => {
          return a.ssOrder > b.ssOrder ? 1 : -1;
        }
      );
    }
  }

  /**
   * @param openAndCloseDialogCreateStep()
   */
  openAndCloseDialogCreateStep() {
    if (this.valueCreateStepDialog === false) {
      this.valueCreateStepDialog = true;
      ExcCoreModule
        .showModal(ModalCreateStepComponent,
          this.sequence.seqID, 'xl',
          {
            enumeration: this.enumeration,
            sequence: this.sequence
          },
          true)
        .subscribe(resultStep => {
          if (resultStep) {
            this.createStep(resultStep);
          }

        });
    } else {
      this.valueCreateStepDialog = false;
    }
  }

  /**
   * @param createStep( any )
   */
  createStep(step: any) {
    this.sequenceIsLoading = true;
    this.excrest.put(this.excrest.computeUrl
      (
        'SelfcheckConfig_Step_Put',
      ),
      step, {}
    ).subscribe
    (response => {
      if (response.success && response.data.length >= 0) {
        let newStep = response.data[0];
        Object.assign(newStep, {stID: newStep.ss_stID});

        // console.log(newStep);
        this.sequence.Steps.push(newStep);
      }
      this.sequenceIsLoading = false;

    });
  }

  /**
   * @param deleteStep()
   */
  deleteStep() {
    //console.log("- Lösche -");
    this.sequenceIsLoading = true;

    for (let ssID of this.checkedSsIdArray) {
      this.excrest.delete(this.excrest.computeUrl
        (
          'SelfcheckConfig_Step_Delete', {ssID}
        ),
        {}, {}
      ).subscribe
      (response => {
        if (response.success && response.data.length >= 0) {
          this.sequence.Steps = this.sequence.Steps.filter(step => step.ssID !== ssID);
          if (this.sequence.Steps.length > 0) {
            let counter = 1;
            for (let objStep of this.sequence.Steps) {
              objStep.ssOrder = counter;
              counter++;
            }
          }
        }
        setTimeout(() => {
          this.sequenceIsLoading = false;
          this.valueDeleteStepDialog = false;
        }, 10);

      });
    }
  }

  /**
   * @param checkSsId( any )
   */
  checkSsId(selectedSsID: any) {
    if (!this.checkedSsIdArray.find((ssId) => ssId == selectedSsID)) {
      this.checkedSsIdArray.push(selectedSsID)
    } else {
      this.checkedSsIdArray = this.checkedSsIdArray.filter((ssId) => ssId != selectedSsID);
    }
    if (this.checkedSsIdArray.length >= 1) {
      this.checkedSsIdArrayValue = true;
    } else {
      this.checkedSsIdArrayValue = false;
    }
  }

  /**
   * @param openAndCloseDeleteStep()
   */
  openAndCloseDeleteStep() {
    if (this.valueDeleteStepDialog === false) {
      this.valueDeleteStepDialog = true;
    } else {
      this.valueDeleteStepDialog = false;
    }
    this.checkedSsIdArray = [];
  }

  /**
   * @param abortDeleteDialog()
   */
  abortDeleteDialog() {
    this.valueDeleteStepDialog = false;
  }

  /**
   * @param changeSwitchMode()
   */
  changeSwitchMode() {
    if (this.switchMode === false) {
      this.switchMode = true;
    } else {
      this.switchMode = false;
    }
  }

}
